import { z } from 'zod';

// Znormalizované dáta z registra (ORSF/RPO a pod.) — nezávislé od konkrétneho zdroja.
// Rovnaký tvar ako CRM Marstein (packages/shared/src/registry.ts) — port, nie zdieľaný balík
// (viď docs/01-architektura-a-datove-zdroje.md §1).
export const registryDataSchema = z.object({
  name: z.string().optional(),
  ico: z.string().optional(),
  dic: z.string().optional(),
  icDph: z.string().optional(),
  address: z
    .object({
      street: z.string().optional(),
      city: z.string().optional(),
      zip: z.string().optional(),
      country: z.string().optional(),
    })
    .optional(),
  source: z.string(), // napr. 'orsf'
  raw: z.unknown().optional(),
});
export type RegistryData = z.infer<typeof registryDataSchema>;
